export const baseSales = {
  "1": "DIARIA",
  "2": "PROMEDIO DIARIA SEMANAL",
  "3": "SEMANAL",
  "4": "MENSUAL",
};

export const typeSales = {
  "0": "NO APLICA",
  "1": "CONTADO",
  "2": "CREDITO",
};

export const tabulators = { //Ya esta en back
  "0": "NO APLICA",
  "1": "RANGO UNICO",
  "2": "EXCEDENTES",
  "3": "COMISION UNICA POR RANGO",
};

export const customerTypes = { //Ya esta en back
  "00": "NO APLICA",
  "01": "DOMESTICO",
  "02": "MAYOREO",
  "03": "CONDOMINIO",
  "04": "ECC",
  "05": "DEMACSA",
  "06": "CHILUCA",
};

export const futures = { //Ya esta en back
  "0": "NO APLICA",
  "1": "INGRESO HASTA 31/12/2012",
  "2": "INGRESO HASTA 01/01/2012",
};

export const periods = {
  "1": "DIARIO",
  "2": "SEMANAL",
  "3": "MENSUAL",
};

export const routes = {
  "0": "NO APLICA",
  "1": "LOCAL",
  "2": "FORANEA",
};

export const transferTypes = {
  "0": "NO APLICA",
  "1": "TRASPASO",
  "2": "MAYOREO",
};